import { render, staticRenderFns } from "./MarkAsVerifiedBtn.vue?vue&type=template&id=dbc56c3e&scoped=true&"
import script from "./MarkAsVerifiedBtn.vue?vue&type=script&lang=js&"
export * from "./MarkAsVerifiedBtn.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsVerifiedBtn.vue?vue&type=style&index=0&id=dbc56c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc56c3e",
  null
  
)

export default component.exports